// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SignatureV1EnvelopeResendResendResponse {
    static getAttributeTypeMap() {
        return SignatureV1EnvelopeResendResendResponse.attributeTypeMap;
    }
}
SignatureV1EnvelopeResendResendResponse.discriminator = undefined;
SignatureV1EnvelopeResendResendResponse.additionalProperties = false;
SignatureV1EnvelopeResendResendResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=signatureV1EnvelopeResendResendResponse.js.map